module.exports = __webpack_public_path__ + "media/images/alerts-icon-1136c749d359595573591d5867c77239.svg";